var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-main',[_c('DashboardBar'),_c('DashboardGrid'),_c('projects-create'),_c('projects-edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }